import { render, staticRenderFns } from "./master-child.vue?vue&type=template&id=4b92e99f"
import script from "./master-child.vue?vue&type=script&lang=js"
export * from "./master-child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b92e99f')) {
      api.createRecord('4b92e99f', component.options)
    } else {
      api.reload('4b92e99f', component.options)
    }
    module.hot.accept("./master-child.vue?vue&type=template&id=4b92e99f", function () {
      api.rerender('4b92e99f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Masters/master-child.vue"
export default component.exports